import { Container } from "../Container/Container";
import { ButtonSocialNetworks } from "../Button/ButtonSocialNetworks";

export const Hero = () => {
  return (
    <div className="flex-1 relative flex items-center">
      <Container>
        <div className="relative flex flex-col items-center md:flex-row md:justify-center md:mt-8 md:items-center py-6">
          <h1 className="title-hero">
            DUO
            <br />
            DURAND<span>-LE LUDEC</span>
            <br />
            DANIEL
          </h1>
        </div>
        <div className="flex justify-center p-2">
          <ButtonSocialNetworks variant="hero" />
        </div>
      </Container>
    </div>
  );
};
